import Vue from 'vue';

// docs: https://www.npmjs.com/package/@fortawesome/vue-fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCloud,
  faCloudMoon,
  faCloudUploadAlt,
  faCloudShowersHeavy,
  faCloudSun,
  faCloudSunRain,
  faEye,
  faHistory,
  faMapMarkedAlt,
  faMoon,
  faPencilAlt,
  faRobot,
  faSearch,
  faSmog,
  faSnowflake,
  faSpinner,
  faSun,
  faTools,
} from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle, faClock, faQuestionCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faCheckCircle,
  faClock,
  faCloud,
  faCloudMoon,
  faCloudUploadAlt,
  faCloudShowersHeavy,
  faCloudSun,
  faCloudSunRain,
  faEye,
  faHistory,
  faMapMarkedAlt,
  faMoon,
  faPencilAlt,
  faQuestionCircle,
  faRobot,
  faSearch,
  faSmog,
  faSnowflake,
  faSpinner,
  faSun,
  faTimesCircle,
  faTools
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
